import React from 'react';

function Footer() {
    return (
        <footer className="bg-white sticky-footer">
        </footer>
    )
}

export default Footer;